import { render } from "./TelefoneInternacional.vue?vue&type=template&id=7440e6b2&scoped=true"
import script from "./TelefoneInternacional.vue?vue&type=script&lang=js"
export * from "./TelefoneInternacional.vue?vue&type=script&lang=js"

import "./TelefoneInternacional.vue?vue&type=style&index=0&id=7440e6b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7440e6b2"]])

export default __exports__